module.exports = __webpack_public_path__ + "img/tddg-8.58ee2ed2.webp";